module.exports = __webpack_public_path__ + "img/aspect-ratio-fill.843da6b1.svg";